import React from "react";

function VerticalTab(props) {
  return <div>{props.children}</div>;
}
export default VerticalTab;
